import { render, staticRenderFns } from "./NewFailure.vue?vue&type=template&id=6531fb38"
import script from "./NewFailure.vue?vue&type=script&lang=js"
export * from "./NewFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports